import { saveCollectGoods, deleteCollectGoods, directDetail } from '@/api/mall/mallGoods'
import { Toast } from 'vant'

const state = {
  mallActive: 2, // 商城顶部tabs标签，1：省购，2：微课
  goodsDetail: {}, // 商品详情
  liveGoodsDetail: {}, // 直播的商品详情
  shopDetail: {}, // 店铺详情
  // isCollect: false, // 商品是否已收藏
  
  shenggouTabsOnTop: false,//省购tabs标签是否固定在顶部
  goodsTabsOnTop: false,//商品tabs标签是否固定在顶部
  
  
}

const mutations = {
  change_mallActive: (state, mallActive) => {
    state.mallActive = mallActive
  },
  change_goodsDetail: (state, goodsDetail) => {
    state.goodsDetail = goodsDetail
  },
  change_shopDetail: (state, shopDetail) => {
    state.shopDetail = shopDetail
  },
  
  change_goods_isCollect:(state, isCollect)=>{
    state.goodsDetail.isCollect = isCollect
  },
  live_goods_detail: ( state, data ) => {
    state.liveGoodsDetail = data
  },
  change_shenggouTabsOnTop: (state, falg) => {
    state.shenggouTabsOnTop = falg
  },
  change_goodsTabsOnTop: (state, falg) => {
    state.goodsTabsOnTop = falg
  },
}

const actions = {
  changeMallActive: ({ commit }, mallActive) => {
    commit('change_mallActive', mallActive)
  },
  changeGoodsDetail: ({ commit }, goodsDetail) => {
    commit('change_goodsDetail', goodsDetail)
  },
  changeShopDetail: ({ commit }, shopDetail) => {
    commit('change_shopDetail', shopDetail)
  },
  changeGoodsCollect:({ commit }, data)=>{
    // commit('change_goods_isCollect', isCollect)
    if(data.isCollect){ // 收藏商品
      return new Promise((resolve, reject) => {
        saveCollectGoods({goodsId: data.goodsId, shopId: data.shopId}).then(res=>{
          if(res.code===200){
            commit('change_goods_isCollect', true)
            Toast({message: '已收藏',duration: 600})
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }else { // 取消收藏商品
      return new Promise((resolve, reject) => {
        deleteCollectGoods({goodsId: data.goodsId, shopId: data.shopId}).then(res=>{
          if(res.code===200){
            commit('change_goods_isCollect', false)
            Toast({message: '已取消收藏', duration: 600})
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  
  
  },
  //获取商品(直播)详情
  getGoodsDetail: ({ commit }, data)=>{
    return new Promise((resolve, reject) => {
      directDetail(data).then(res=>{
        if(res.code===200){
          commit('live_goods_detail', res.data)
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
